// Curated list of Australian cities, suburbs and towns relevant to backpackers
// Covers: capital cities, mining towns (WA/QLD/NT), backpacker hubs, farm work regions (88 days)
// State codes: NSW, VIC, QLD, WA, SA, TAS, NT, ACT

export const AU_CITIES = [
  // ===== CAPITAL CITIES =====
  { name: "Sydney", state: "NSW", postcode: "2000" },
  { name: "Melbourne", state: "VIC", postcode: "3000" },
  { name: "Brisbane", state: "QLD", postcode: "4000" },
  { name: "Perth", state: "WA", postcode: "6000" },
  { name: "Adelaide", state: "SA", postcode: "5000" },
  { name: "Hobart", state: "TAS", postcode: "7000" },
  { name: "Darwin", state: "NT", postcode: "0800" },
  { name: "Canberra", state: "ACT", postcode: "2600" },

  // ===== WA — MINING (Pilbara, Goldfields, Kimberley) =====
  { name: "Karratha", state: "WA", postcode: "6714" },
  { name: "Port Hedland", state: "WA", postcode: "6721" },
  { name: "South Hedland", state: "WA", postcode: "6722" },
  { name: "Newman", state: "WA", postcode: "6753" },
  { name: "Tom Price", state: "WA", postcode: "6751" },
  { name: "Paraburdoo", state: "WA", postcode: "6754" },
  { name: "Dampier", state: "WA", postcode: "6713" },
  { name: "Wickham", state: "WA", postcode: "6720" },
  { name: "Onslow", state: "WA", postcode: "6710" },
  { name: "Roebourne", state: "WA", postcode: "6718" },
  { name: "Kalgoorlie", state: "WA", postcode: "6430" },
  { name: "Boulder", state: "WA", postcode: "6432" },
  { name: "Kambalda", state: "WA", postcode: "6442" },
  { name: "Coolgardie", state: "WA", postcode: "6429" },
  { name: "Leonora", state: "WA", postcode: "6438" },
  { name: "Laverton", state: "WA", postcode: "6440" },
  { name: "Menzies", state: "WA", postcode: "6436" },
  { name: "Norseman", state: "WA", postcode: "6443" },
  { name: "Esperance", state: "WA", postcode: "6450" },
  { name: "Broome", state: "WA", postcode: "6725" },
  { name: "Derby", state: "WA", postcode: "6728" },
  { name: "Kununurra", state: "WA", postcode: "6743" },
  { name: "Halls Creek", state: "WA", postcode: "6770" },
  { name: "Wyndham", state: "WA", postcode: "6740" },
  { name: "Fitzroy Crossing", state: "WA", postcode: "6765" },

  // ===== WA — Perth metro & surrounds =====
  { name: "Fremantle", state: "WA", postcode: "6160" },
  { name: "Joondalup", state: "WA", postcode: "6027" },
  { name: "Mandurah", state: "WA", postcode: "6210" },
  { name: "Rockingham", state: "WA", postcode: "6168" },
  { name: "Bunbury", state: "WA", postcode: "6230" },
  { name: "Busselton", state: "WA", postcode: "6280" },
  { name: "Margaret River", state: "WA", postcode: "6285" },
  { name: "Albany", state: "WA", postcode: "6330" },
  { name: "Geraldton", state: "WA", postcode: "6530" },
  { name: "Kalbarri", state: "WA", postcode: "6536" },
  { name: "Carnarvon", state: "WA", postcode: "6701" },
  { name: "Exmouth", state: "WA", postcode: "6707" },
  { name: "Cannington", state: "WA", postcode: "6107" },
  { name: "Scarborough", state: "WA", postcode: "6019" },
  { name: "Cottesloe", state: "WA", postcode: "6011" },
  { name: "Northbridge", state: "WA", postcode: "6003" },
  { name: "Subiaco", state: "WA", postcode: "6008" },

  // ===== QLD — Mining & remote =====
  { name: "Mount Isa", state: "QLD", postcode: "4825" },
  { name: "Cloncurry", state: "QLD", postcode: "4824" },
  { name: "Moranbah", state: "QLD", postcode: "4744" },
  { name: "Dysart", state: "QLD", postcode: "4745" },
  { name: "Blackwater", state: "QLD", postcode: "4717" },
  { name: "Emerald", state: "QLD", postcode: "4720" },
  { name: "Clermont", state: "QLD", postcode: "4721" },
  { name: "Roma", state: "QLD", postcode: "4455" },
  { name: "Chinchilla", state: "QLD", postcode: "4413" },
  { name: "Charters Towers", state: "QLD", postcode: "4820" },

  // ===== QLD — Coast / Backpacker hubs =====
  { name: "Cairns", state: "QLD", postcode: "4870" },
  { name: "Port Douglas", state: "QLD", postcode: "4877" },
  { name: "Townsville", state: "QLD", postcode: "4810" },
  { name: "Airlie Beach", state: "QLD", postcode: "4802" },
  { name: "Mackay", state: "QLD", postcode: "4740" },
  { name: "Rockhampton", state: "QLD", postcode: "4700" },
  { name: "Gladstone", state: "QLD", postcode: "4680" },
  { name: "Bundaberg", state: "QLD", postcode: "4670" },
  { name: "Hervey Bay", state: "QLD", postcode: "4655" },
  { name: "Maryborough", state: "QLD", postcode: "4650" },
  { name: "Noosa Heads", state: "QLD", postcode: "4567" },
  { name: "Sunshine Coast", state: "QLD", postcode: "4551" },
  { name: "Maroochydore", state: "QLD", postcode: "4558" },
  { name: "Caloundra", state: "QLD", postcode: "4551" },
  { name: "Gold Coast", state: "QLD", postcode: "4217" },
  { name: "Surfers Paradise", state: "QLD", postcode: "4217" },
  { name: "Burleigh Heads", state: "QLD", postcode: "4220" },
  { name: "Coolangatta", state: "QLD", postcode: "4225" },
  { name: "Toowoomba", state: "QLD", postcode: "4350" },
  { name: "Ipswich", state: "QLD", postcode: "4305" },
  { name: "Stanthorpe", state: "QLD", postcode: "4380" },
  { name: "Childers", state: "QLD", postcode: "4660" },
  { name: "Ayr", state: "QLD", postcode: "4807" },
  { name: "Bowen", state: "QLD", postcode: "4805" },
  { name: "Innisfail", state: "QLD", postcode: "4860" },
  { name: "Tully", state: "QLD", postcode: "4854" },

  // ===== NSW — Sydney metro + regional =====
  { name: "Bondi", state: "NSW", postcode: "2026" },
  { name: "Bondi Beach", state: "NSW", postcode: "2026" },
  { name: "Coogee", state: "NSW", postcode: "2034" },
  { name: "Manly", state: "NSW", postcode: "2095" },
  { name: "Newtown", state: "NSW", postcode: "2042" },
  { name: "Surry Hills", state: "NSW", postcode: "2010" },
  { name: "Parramatta", state: "NSW", postcode: "2150" },
  { name: "Liverpool", state: "NSW", postcode: "2170" },
  { name: "Penrith", state: "NSW", postcode: "2750" },
  { name: "Wollongong", state: "NSW", postcode: "2500" },
  { name: "Newcastle", state: "NSW", postcode: "2300" },
  { name: "Maitland", state: "NSW", postcode: "2320" },
  { name: "Central Coast", state: "NSW", postcode: "2250" },
  { name: "Gosford", state: "NSW", postcode: "2250" },
  { name: "Coffs Harbour", state: "NSW", postcode: "2450" },
  { name: "Port Macquarie", state: "NSW", postcode: "2444" },
  { name: "Byron Bay", state: "NSW", postcode: "2481" },
  { name: "Lismore", state: "NSW", postcode: "2480" },
  { name: "Ballina", state: "NSW", postcode: "2478" },
  { name: "Tweed Heads", state: "NSW", postcode: "2485" },
  { name: "Tamworth", state: "NSW", postcode: "2340" },
  { name: "Armidale", state: "NSW", postcode: "2350" },
  { name: "Orange", state: "NSW", postcode: "2800" },
  { name: "Bathurst", state: "NSW", postcode: "2795" },
  { name: "Dubbo", state: "NSW", postcode: "2830" },
  { name: "Wagga Wagga", state: "NSW", postcode: "2650" },
  { name: "Albury", state: "NSW", postcode: "2640" },
  { name: "Griffith", state: "NSW", postcode: "2680" },
  { name: "Mudgee", state: "NSW", postcode: "2850" },
  { name: "Broken Hill", state: "NSW", postcode: "2880" },

  // ===== VIC — Melbourne metro + regional =====
  { name: "St Kilda", state: "VIC", postcode: "3182" },
  { name: "Fitzroy", state: "VIC", postcode: "3065" },
  { name: "Richmond", state: "VIC", postcode: "3121" },
  { name: "Brunswick", state: "VIC", postcode: "3056" },
  { name: "Carlton", state: "VIC", postcode: "3053" },
  { name: "Footscray", state: "VIC", postcode: "3011" },
  { name: "Frankston", state: "VIC", postcode: "3199" },
  { name: "Dandenong", state: "VIC", postcode: "3175" },
  { name: "Geelong", state: "VIC", postcode: "3220" },
  { name: "Torquay", state: "VIC", postcode: "3228" },
  { name: "Ballarat", state: "VIC", postcode: "3350" },
  { name: "Bendigo", state: "VIC", postcode: "3550" },
  { name: "Shepparton", state: "VIC", postcode: "3630" },
  { name: "Mildura", state: "VIC", postcode: "3500" },
  { name: "Robinvale", state: "VIC", postcode: "3549" },
  { name: "Swan Hill", state: "VIC", postcode: "3585" },
  { name: "Echuca", state: "VIC", postcode: "3564" },
  { name: "Wodonga", state: "VIC", postcode: "3690" },
  { name: "Warrnambool", state: "VIC", postcode: "3280" },
  { name: "Mornington", state: "VIC", postcode: "3931" },
  { name: "Mernda", state: "VIC", postcode: "3754" },
  { name: "Lorne", state: "VIC", postcode: "3232" },
  { name: "Apollo Bay", state: "VIC", postcode: "3233" },

  // ===== SA — Adelaide metro + regional =====
  { name: "Glenelg", state: "SA", postcode: "5045" },
  { name: "Port Adelaide", state: "SA", postcode: "5015" },
  { name: "Mount Gambier", state: "SA", postcode: "5290" },
  { name: "Whyalla", state: "SA", postcode: "5600" },
  { name: "Port Augusta", state: "SA", postcode: "5700" },
  { name: "Port Lincoln", state: "SA", postcode: "5606" },
  { name: "Murray Bridge", state: "SA", postcode: "5253" },
  { name: "Renmark", state: "SA", postcode: "5341" },
  { name: "Berri", state: "SA", postcode: "5343" },
  { name: "Loxton", state: "SA", postcode: "5333" },
  { name: "Barossa Valley", state: "SA", postcode: "5352" },
  { name: "Roxby Downs", state: "SA", postcode: "5725" },
  { name: "Coober Pedy", state: "SA", postcode: "5723" },
  { name: "Victor Harbor", state: "SA", postcode: "5211" },

  // ===== TAS =====
  { name: "Launceston", state: "TAS", postcode: "7250" },
  { name: "Devonport", state: "TAS", postcode: "7310" },
  { name: "Burnie", state: "TAS", postcode: "7320" },
  { name: "Kingston", state: "TAS", postcode: "7050" },
  { name: "Sandy Bay", state: "TAS", postcode: "7005" },

  // ===== NT =====
  { name: "Alice Springs", state: "NT", postcode: "0870" },
  { name: "Katherine", state: "NT", postcode: "0850" },
  { name: "Tennant Creek", state: "NT", postcode: "0860" },
  { name: "Palmerston", state: "NT", postcode: "0830" },
  { name: "Nhulunbuy", state: "NT", postcode: "0880" },
  { name: "Yulara", state: "NT", postcode: "0872" },

  // ===== ACT =====
  { name: "Belconnen", state: "ACT", postcode: "2617" },
  { name: "Gungahlin", state: "ACT", postcode: "2912" },
  { name: "Tuggeranong", state: "ACT", postcode: "2900" },
  { name: "Woden", state: "ACT", postcode: "2606" },
];
